<template>
  <div
    id="modalDoneAction"
    class="modal fade"
    tabindex="-1"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Ação</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            &times;
          </button>
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group mb-1 col-sm-12">
                <p class="mb-0">
                  <label class="mb-0">
                    Implementação: <span class="text-danger">*</span>
                  </label>
                </p>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="implementadaNao"
                    value="Não"
                    v-model="$v.action.implementada.$model"
                  />
                  <label class="form-check-label" for="implementadaNao">
                    Não
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="implementadaSim"
                    value="Sim"
                    v-model="$v.action.implementada.$model"
                  />
                  <label class="form-check-label" for="implementadaSim">
                    Sim
                  </label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label>
                  Registro dos Resultados (Evidências):
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  class="form-control"
                  :class="{ 'is-invalid': $v.action.resultado.$error }"
                  placeholder="Descreva os resultados"
                  rows="4"
                  v-model="$v.action.resultado.$model"
                />
                <span
                  v-if="!$v.action.resultado.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              v-if="!doneAction"
              type="button"
              class="btn btn-warning"
              data-dismiss="modal"
              title="Reabrir"
              @click="$emit('unDoneAction')"
            >
              Reabrir
            </button>
            <button
              type="submit"
              class="btn btn-theme"
              :title="textModal"
              :disabled="$v.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="fas fa-spinner fa-spin"></i>
              </span>
              <span v-else>
                {{ textModal }}
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'DoneActionModal',

  props: {
    registryId: {
      type: String,
      required: true,
    },
    actionId: {
      type: String,
      required: true,
    },
    doneAction: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      action: {
        implementada: '',
        resultado: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.doneAction ? 'Concluir' : 'Atualizar'
    },
  },

  methods: {
    async getAction() {
      try {
        this.action = await this.$store.dispatch('getAction', {
          registryId: this.registryId,
          actionId: this.actionId,
        })
        window.$('#modalDoneAction').modal()
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.$v.$invalid) {
        this.disableButton = true
        try {
          let response = null
          if (this.doneAction) {
            response = await this.$store.dispatch('doneAction', {
              registryId: this.registryId,
              actionId: this.actionId,
              action: this.action,
            })
          } else {
            response = await this.$store.dispatch('updateAction', {
              registryId: this.registryId,
              actionId: this.actionId,
              action: this.action,
            })
          }
          this.disableButton = false
          window.$('#modalDoneAction').modal('hide')
          this.$emit('closeModal', true)
          this.$snotify.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$snotify.warning(error.message, 'Atenção!')
          } else {
            this.$snotify.error(
              'Não foi possível se conectar ao servidor.',
              'Erro!',
            )
          }
        }
      }
    },
  },

  validations: {
    action: {
      implementada: {
        required,
      },
      resultado: {
        required,
      },
    },
  },

  mounted() {
    this.getAction()
  },
}
</script>

<style scoped>
.form-check-label {
  color: #494c5e;
}
</style>
